import { FC } from 'react'

import { useParams } from 'react-router-dom'
import styled from 'styled-components'

import { useGetMetaAdsCampaignByIdQuery } from 'src/Redux/adsCampaignApi'
import { AdCampaignStrategyEnum } from 'src/Redux/ad-campaignApi'

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`

const Title = styled.h2`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  margin: 0;
`

export const AdsGenresModalHeader: FC = () => {
  const { number } = useParams()
  const { data } = useGetMetaAdsCampaignByIdQuery(Number(number))

  const headerText =
    data?.strategy === AdCampaignStrategyEnum.PLAYLIST
      ? 'Playlist genres'
      : 'Genres'

  return (
    <Header>
      <Title>{headerText}</Title>
    </Header>
  )
}
